import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';
import { cashSettlementFactory } from '../utils/settlement';

type TUseUpdateCashSettlementQueryConfigs = {
  onReject?: UseMutationConfig<any>['onReject'];
  onSuccess?: UseMutationConfig<any>['onSuccess'];
};

export default function useUpdateCashSettlementQuery({
  onReject,
  onSuccess,
}: TUseUpdateCashSettlementQueryConfigs) {
  const {
    isPending: isLoadingUpdateCashSettlement,
    isError: isErrorUpdateCashSettlement,
    execute: updateCashSettlement,
    isSuccess: isSuccessUpdateCashSettlement,
    ...query
  } = useMutation(
    ({ formModel }) =>
      API.updateCashSettlement(cashSettlementFactory(formModel)),
    { onReject, onSuccess }
  );

  return {
    updateCashSettlement,
    isErrorUpdateCashSettlement,
    isLoadingUpdateCashSettlement,
    isSuccessUpdateCashSettlement,
    query,
  };
}
